// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/* Visually hide the element */\n.jIi6N {\n  -webkit-transform: scale(0);\n      -ms-transform: scale(0);\n          transform: scale(0);\n  position: absolute;\n  top: calc(var(--schoolinks-appbar-height)*-2);\n  left: calc(var(--schoolinks-appbar-height)*-2);\n  z-index: -1;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"input": "jIi6N"
};
export default ___CSS_LOADER_EXPORT___;
